// extracted by mini-css-extract-plugin
module.exports = {"favorite-icon":"favorite_favorite-icon__M2Djk"};